export default __webpack_public_path__ + "img/account-outline.b206c4f8.svg";